<nz-row nzJustify="space-between" nzAlign="middle" *ngIf="projectId && projectId.id">
  <nz-col style="margin-bottom: 10px;">
    <input nz-input placeholder="Search..." [(ngModel)]="searchText" (ngModelChange)="onSearch()" />
  </nz-col>
  <nz-col>
    <button nz-button nzType="primary" (click)="addTask()">Add</button>
  </nz-col>
</nz-row>


<ng-container *ngIf="taskList.length === 0 && !loading && !hasActiveFilter; else showTable">
  <div class="empty-state-container">
    <div class="empty-state-content">
      <div class="icon-circle">
        <i class="fa-solid fa-folder-plus"></i>
      </div>

      <h3>No Task List Found</h3>
      <p *ngIf="!projectId || !projectId.id">Please add a project to the event to access tasks.</p>
      <!-- <p *ngIf="!projectId || !projectId.id">Please add a project to the event to access tasks.</p> -->
      <p *ngIf="projectId && projectId.id">Please add a task to the event.</p>

      <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="100" r="75" fill="#F3F4F6" />

        <rect x="75" y="60" width="70" height="90" rx="2" transform="rotate(-5 75 60)" fill="white" stroke="#D1D5DB"
          stroke-width="2" />

        <rect x="65" y="50" width="70" height="90" rx="2" fill="white" stroke="#9CA3AF" stroke-width="2" />

        <rect x="75" y="65" width="10" height="10" rx="2" stroke="#E5E7EB" stroke-width="2" />
        <line x1="92" y1="70" x2="120" y2="70" stroke="#E5E7EB" stroke-width="2" stroke-linecap="round" />

        <rect x="75" y="85" width="10" height="10" rx="2" stroke="#E5E7EB" stroke-width="2" />
        <line x1="92" y1="90" x2="120" y2="90" stroke="#E5E7EB" stroke-width="2" stroke-linecap="round" />

        <circle cx="125" cy="125" r="20" fill="white" stroke="#3B82F6" stroke-width="2" />
        <path d="M138 138L145 145" stroke="#3B82F6" stroke-width="3" stroke-linecap="round" />
      </svg>

    </div>
  </div>
</ng-container>
<ng-template #showTable>
  <nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">
    <div class="cet-tasks-table-scroll">
      <nz-table [nzData]="taskList" [nzBordered]="true" [nzSize]="'middle'"
        [nzShowPagination]="false">
      <thead>
        <tr>
          <th nzWidth="80px">ID</th>
          <th nzWidth="260px">Task</th>
          <th nzCustomFilter nzWidth="120px">Priority
            <nz-filter-trigger [(nzVisible)]="priorityVisible" [nzActive]="taskFilter.priority > 0"
              [nzDropdownMenu]="menupriority">
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
            <nz-dropdown-menu #menupriority="nzDropdownMenu">
              <div class="ant-table-filter-dropdown">
                <div class="search-box">
                  <nz-select ngModel="taskFilter.priority" nzAllowClear (ngModelChange)="onChange($event, 'priority')"
                    nzPlaceHolder="Filter Priority" style="width:200px">
                    <nz-option *ngFor="let priority of listOfPriority" [nzValue]="priority.id"
                      [nzLabel]="priority.name"></nz-option>
                  </nz-select>
                </div>
              </div>
            </nz-dropdown-menu>
          </th>
          <th nzWidth="160px" class="due-date-column">Due Date</th>
          <th nzCustomFilter>Assigned (User)
            <nz-filter-trigger [(nzVisible)]="userVisible" [nzActive]="taskFilter.assigned_to  > 0"
              [nzDropdownMenu]="menuuser">
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
            <nz-dropdown-menu #menuuser="nzDropdownMenu">
              <div class="ant-table-filter-dropdown">
                <div class="search-box">
                  <nz-select ngModel="taskFilter.assigned_to" nzAllowClear
                    (ngModelChange)="onChange($event, 'assigned_to')" nzPlaceHolder="Filter User" style="width:200px">
                    <nz-option *ngFor="let user of userlist" [nzValue]="user.id" [nzLabel]="user.name"></nz-option>
                  </nz-select>
                </div>
              </div>
            </nz-dropdown-menu>
          </th>
          <th nzCustomFilter>Assigned (Group)
            <nz-filter-trigger [(nzVisible)]="groupVisible" [nzActive]="taskFilter.assigned_to_group > 0"
              [nzDropdownMenu]="menuusergroup">
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
            <nz-dropdown-menu #menuusergroup="nzDropdownMenu">
              <div class="ant-table-filter-dropdown">
                <div class="search-box">
                  <nz-select ngModel="taskFilter.assigned_to_group" nzAllowClear
                    (ngModelChange)="onChange($event, 'assigned_to_group')" nzPlaceHolder="Filter User Group"
                    style="width:200px">
                    <nz-option *ngFor="let user of usergrouplist" [nzValue]="user.id" [nzLabel]="user.name"></nz-option>
                  </nz-select>
                </div>
              </div>
            </nz-dropdown-menu>
          </th>
          <th nzCustomFilter nzWidth="100px">Status
            <nz-filter-trigger [(nzVisible)]="statusVisible" [nzActive]="taskFilter.task_status > 0"
              [nzDropdownMenu]="menustatus">
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
            <nz-dropdown-menu #menustatus="nzDropdownMenu">
              <div class="ant-table-filter-dropdown">
                <div class="search-box">
                  <nz-select ngModel="taskFilter.task_status" nzAllowClear
                    (ngModelChange)="onChange($event, 'task_status')" nzPlaceHolder="Filter Status" style="width:200px">
                    <nz-option *ngFor="let status of listOfTaskStatus" [nzValue]="status.id"
                      [nzLabel]="status.name"></nz-option>
                  </nz-select>
                </div>
              </div>
            </nz-dropdown-menu>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="taskList.length === 0 && !loading">
          <td colspan="7" style="text-align: center; padding: 40px; color: #999;">
            <nz-empty nzNotFoundContent="No data found. Please adjust or clear your filters."></nz-empty>
          </td>
        </tr>
        <tr *ngFor="let task of taskList">
          <td style="width:60px"> <nz-tag> {{ formatIdToFourDigits(task.id) }} </nz-tag> </td>
          <td style="font-weight: bold;width:300px" (click)="goToTaskDetailModal(task)"> <a href="javascript:void(0)">
              {{ task.name }}</a></td>
          <td>
            <nz-tag [nzColor]="
                  task.priority === 'High' ? 'red' :
                  task.priority === 'Medium' ? 'orange' : 'blue'
                ">
              {{ taskPriorityName(task.priority) }}
            </nz-tag>
          </td>
          <td class="due-date-column">{{ task.due_date | date: 'mediumDate' }}</td>
          <td>
            <nz-avatar-group>
              <nz-avatar nzSize="small" *ngFor="let users of task.assigned_to_details" nz-tooltip
                [nzTooltipTitle]="users.name" nzIcon="user" [nzSrc]="getBase64Image(users.image)"></nz-avatar>
            </nz-avatar-group>
          </td>
          <td>
            <nz-tag [nzColor]="'purple'" *ngFor="let user of task?.assigned_to_group_details" [nzBordered]="false">
              {{user?.name}}
            </nz-tag>
          </td>
          <td>
            <nz-badge [nzStatus]="getStatusBadge(task.task_status_name)"
              [nzText]="getTaskStatusName(task.task_status)"></nz-badge>
          </td>
        </tr>
      </tbody>
      </nz-table>
    </div>
  </nz-spin>
</ng-template>
<app-console-project-detail [isVisible]="showTaskDetail" [tabData]="selectData" [type]="selectedType"
  (openTaskDetailEventOnDetail)="goToTaskDetailModal($event)"
  (closeModal)="closeTaskDetail()"></app-console-project-detail>
